import React, { useEffect, useState, useRef } from 'react';
import { getDasboard, getLogs, getLog } from '../../Services/AppService';
import MTable from "../../Components/MTable/MTable";
import Overlay from '../../Components/Overlay/Overlay';
import ReactJson from '@textea/json-viewer'
import { NavLink } from "react-router-dom";
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import { useSelector } from 'react-redux';
import { toastError } from "../../Components/Toasts/Toast";
import CustomButton from '../../Components/Button/CustomButton';
import { uuid } from '../../Utils/Utils';

let processingId = -1;

const HomePage = () => {
  const darkMode = useSelector(state => state.theme.darkMode);

  const mTable = useRef();
  const [state, setState] = useState({
    dashboard: {},
    options: {},
    processing: false,
    showForm: false,
    log: {}
  });

  const startProcessing = () => {
    processingId = setTimeout(() => {
      setState({ ...state, processing: true });
    }, 150);
  };

  const stopProcessing = () => {
    clearTimeout(processingId);
    setState({ ...state, processing: false });
  };

  const onEdit = (item) => {
    startProcessing();
    getLog(item._id).then(res => {
      clearTimeout(processingId);
      setState({ ...state, log: res.data, showForm: true, processing: false });
    }).catch(({ response: { error } }) => {
      toastError('Error while get data from server!');
    })
  }

  const onCloseForm = () => {
    setState({ ...state, log: {}, showForm: false });
  }

  const columns = [
    { id: uuid(), title: "Log Date", field: "log_date", sortable: true },
    { id: uuid(), title: "Items", field: "items", sortable: true, style: {
      overflow: `hidden`,
      textOverflow: `ellipsis`,
      width: 250
    } },
    { id: uuid(), title: "Transaction Type", field: "transaction", sortable: true },
    { id: uuid(), title: "Message", field: "message", sortable: true },
    {
      id: uuid(), title: "Status", field: "status", sortable: true,
      render: (item) => item.status != 200 && item.status != 201
        ? <span style={{ color: 'red' }}>{item.status}</span>
        : <span>{item.status}</span>
    },
    { id: uuid(), title: "Created By", field: "created_by", sortable: true },
    {
      id: uuid(),
      title: "",
      sortable: true,
      style: { width: 200 },
      render: (item) => {
        return (
          <div>
            <CustomButton title="Detail" type="default" icon="fas fa-eye" onClick={() => onEdit(item)} />
          </div>
        );
      },
    },
  ]

  useEffect(() => {
    const reqDashboard = getDasboard().then(res => res.data);
    Promise.all([reqDashboard]).then(results => {
      const [_dashboard] = results;
      const color = darkMode ? '#495057' : '#fff';
      const textColor = darkMode ? '#fff' : '#000';

      setState({
        ...state,
        dashboard: _dashboard,
        options: {
          chart: {
            backgroundColor: color,
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            type: 'pie'
          },
          title: {
            text: 'Image Type On Server',
            style: {
              color: textColor
            }
          },
          tooltip: {
            pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
          },
          accessibility: {
            point: {
              valueSuffix: '%'
            }
          },
          plotOptions: {
            pie: {
              allowPointSelect: true,
              cursor: 'pointer',
              dataLabels: {
                enabled: true,
                format: '<b>{point.name}</b>: {point.percentage:.1f} %',
                connectorColor: 'silver'
              }
            }
          },
          series: [{
            name: 'Image Size',
            data: _dashboard.graph
          }]
        }
      });
    });
  }, [darkMode]);

  const { dashboard, options, processing, showForm, log } = state;

  const propsTable = { defaultSort: '_id', orders: '_id:desc', columns, getData: getLogs, showIndex: true, enableFilter: true };

  useEffect(() => {
    if (!showForm) {
      setTimeout(() => {
        mTable.current.refresh();
      }, 250);
    }
  }, [showForm]);

  return (
    <div className="content-wrapper">
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">Dashboard</h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item active">Home Page</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-4 col-6">
              <div className="small-box bg-info">
                <div className="inner">
                  <h3>{dashboard && dashboard.user}</h3>
                  <p>Active User</p>
                </div>
                <div className="icon">
                  <i className="fas fa-user" />
                </div>
                <NavLink to="/user" className="small-box-footer">More info <i className="fas fa-arrow-circle-right" /></NavLink>
              </div>
            </div>
            <div className="col-lg-4 col-6">
              <div className="small-box bg-success">
                <div className="inner">
                  <h3>{dashboard && dashboard.product}<sup style={{ fontSize: 20 }}></sup></h3>
                  <p>Active Product</p>
                </div>
                <div className="icon">
                  <i className="fas fa-briefcase" />
                </div>
                <NavLink to="/product" className="small-box-footer">More info <i className="fas fa-arrow-circle-right" /></NavLink>
              </div>
            </div>
            <div className="col-lg-4 col-6">
              <div className="small-box bg-warning">
                <div className="inner">
                  <h3>{dashboard && dashboard.sync}<sup style={{ fontSize: 20 }}></sup></h3>
                  <p>Synced To SAP</p>
                </div>
                <div className="icon">
                  <i className="fas fa-briefcase" />
                </div>
                <NavLink to="/" className="small-box-footer">There is {dashboard.notSync} not synced yet!</NavLink>
              </div>
            </div>
          </div>

          <div className='row'>
            <div className='col-md-12'>
              <div className="card">
                <div className="card-header">
                  <h3 className="card-title">
                    <i className="fas fa-chart-pie mr-1" />
                    Asset Type
                  </h3>
                </div>

                <div className='cart-body'>
                  <div className='row'>


                    <div className='col-md-6 p-3'>
                      {options && <HighchartsReact
                        highcharts={Highcharts}
                        options={options}
                      />}
                    </div>
                    <div className="col-md-6 p-5">
                      <div className="small-box bg-orange">
                        <div className="inner">
                          <h3>{dashboard && dashboard.manualBook}</h3>
                          <p>Manual Book</p>
                        </div>
                        <div className="icon">
                          <i className="fas fa-file" />
                        </div>
                      </div>

                      <div className="small-box bg-cyan">
                        <div className="inner">
                          <h3>{dashboard && dashboard.image}</h3>
                          <p>Media Assets</p>
                        </div>
                        <div className="icon">
                          <i className="fas fa-image" />
                        </div>
                      </div>

                      <div className="small-box bg-cyan">
                        <div className="inner">
                          <h3>{dashboard && dashboard.image_size}</h3>
                          <p>Media Files Size</p>
                        </div>
                        <div className="icon">
                          <i className="fas fa-hdd" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='row'>
            <div className='col-md-12'>
              <div className='card'>
                <Overlay display={processing} />
                <div className="card-header">
                  <h3 className="card-title">
                    {
                      !showForm
                        ? <i className="fas fa-tags mr-1" />
                        : <i className="fas fa-arrow-left mr-1 pointer" onClick={onCloseForm} />
                    }

                    {showForm ? 'Detail Log' : 'Sync Logs'}
                  </h3>
                </div>
                <div className='card-body'>
                  <div className={`${!showForm ? 'card__side--front-show' : 'card__side--front'}`}>
                    <MTable ref={mTable} {...propsTable} showIndex={true} />
                  </div>

                  <div className={`${showForm ? 'card__side--back-show' : 'card__side--back'}`}>
                    <div className='row'>
                      <div className='col-md-12'>
                        <div className='card'>
                          <div className='card-body'>
                            <span>Created By</span><br />
                            <span className='text-bold'>{log.created_by || '-'}</span><br />

                            <span>Transaction Type</span><br />
                            <span className='text-bold'>{log.transaction || '-'}</span><br />

                            <span>Items</span><br />
                            <span className='text-bold'>{log.items || '-'}</span><br />

                            <span>Status</span><br />
                            <span className='text-bold'>{log.status || '-'}</span><br />

                            <span>Message</span><br />
                            <span className='text-bold'>{log.message || '-'}</span><br />

                            <span>Request Date</span><br />
                            <span className='text-bold'>{log.log_date || '-'}</span><br />
                          </div>
                        </div>
                      </div>
                      <div className='col-md-6'>
                        <div className='card'>
                          <div className='card-header text-bold'>
                            Payload
                          </div>
                          <div className='card-body'>
                            <ReactJson style={darkMode ? { backgroundColor: "transparent" } : {}} theme={darkMode ? 'codeschool' : 'rjv-default'} src={log.payload} name="payload" />
                          </div>
                        </div>
                      </div>
                      <div className='col-md-6'>
                        <div className='card'>
                          <div className='card-header text-bold'>
                            Response
                          </div>
                          <div className='card-body'>
                            {
                              log.response ? <ReactJson style={darkMode ? { backgroundColor: "transparent" } : {}} theme={darkMode ? 'codeschool' : 'rjv-default'} src={log.response} name="response" /> : 'NULL'
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default HomePage;